import * as React from 'react'
// @ts-ignore
import Loader from 'ui/Loader'
// @ts-ignore
import { fetch as fetchSchool } from '../../../data/school'
// @ts-ignore
import { fetchEditableBySlug } from '../../../data/school/handbook'
import './HandbookPage.module.scss'
// @ts-ignore
import Header from './Header'
// @ts-ignore
import Viewer from './Viewer'

interface IProps {
  schoolSlug: string
}

export default function EditableHandbookPage({ schoolSlug }: IProps) {
  const [handbook, setHandbook] = React.useState('')
  const [school, setSchool] = React.useState(null)
  const [requestInProgress, setRequestInProgress] = React.useState(false)

  const getData = async () => {
    try {
      setRequestInProgress(true)
      const handbookData = await fetchEditableBySlug(schoolSlug)
      const schoolData = await fetchSchool(schoolSlug)
      setSchool(schoolData)
      setHandbook(handbookData)
    } catch (error) {
      return
    } finally {
      setRequestInProgress(false)
    }
  }

  React.useEffect(() => {
    getData()
  }, [])

  if (requestInProgress) return <Loader />
  if (!school || !handbook) return null

  return (
    <div styleName="container">
      <Header school={school} />
      <Viewer handbook={{ htmlContent: handbook }} />
    </div>
  )
}
